// extracted by mini-css-extract-plugin
export default {"root":"Select_root__R+uKu","isMultiSelect":"Select_isMultiSelect__bFLdd","infoDisplay":"Select_infoDisplay__2+ox0","select__single-value":"Select_select__single-value__cF8Sa"};